var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getResourceFileType, getHost, ResourceType, shuffle } from '../../utils/common-utils';
import { PERFORMANCE_RESOURCE_EVENT_TYPE } from '../utils/constant';
export var RESOURCE_EVENT_PLUGIN_ID = 'com.amazonaws.rum.resource';
var RESOURCE = 'resource';
var LOAD = 'load';
export var defaultConfig = {
    eventLimit: 10,
    recordAllTypes: [ResourceType.DOCUMENT, ResourceType.SCRIPT],
    sampleTypes: [
        ResourceType.STYLESHEET,
        ResourceType.IMAGE,
        ResourceType.FONT,
        ResourceType.OTHER
    ]
};
/**
 * This plugin records resource performance timing events generated during every page load/re-load.
 */
var ResourcePlugin = /** @class */ (function () {
    function ResourcePlugin(config) {
        var _this = this;
        this.resourceEventListener = function (event) {
            var recordAll = [];
            var sample = [];
            var eventCount = 0;
            var resourceObserver = new PerformanceObserver(function (list) {
                list.getEntries()
                    .filter(function (e) { return e.entryType === RESOURCE; })
                    .forEach(function (event) {
                    // Out of n resource events, x events are recorded using Observer API
                    var type = getResourceFileType(event.name);
                    if (_this.config.recordAllTypes.includes(type)) {
                        recordAll.push(event);
                    }
                    else if (_this.config.sampleTypes.includes(type)) {
                        sample.push(event);
                    }
                });
            });
            resourceObserver.observe({
                entryTypes: [RESOURCE]
            });
            // Remaining (n-x) resource events are recorded using getEntriesByType API.
            // Note: IE11 browser does not support Performance Observer API. Handle the failure gracefully
            var events = performance.getEntriesByType(RESOURCE);
            if (events !== undefined && events.length > 0) {
                events.forEach(function (event) {
                    var type = getResourceFileType(event.name);
                    if (_this.config.recordAllTypes.includes(type)) {
                        recordAll.push(event);
                    }
                    else if (_this.config.sampleTypes.includes(type)) {
                        sample.push(event);
                    }
                });
            }
            // Record events for resources in recordAllTypes
            shuffle(recordAll);
            while (recordAll.length > 0 && eventCount < _this.config.eventLimit) {
                _this.recordResourceEvent(recordAll.pop());
                eventCount++;
            }
            // Record events sampled from resources in sample
            shuffle(sample);
            while (sample.length > 0 && eventCount < _this.config.eventLimit) {
                _this.recordResourceEvent(sample.pop());
                eventCount++;
            }
        };
        this.recordResourceEvent = function (entryData) {
            if (_this.recordEvent &&
                getHost(entryData.name) !== getHost(_this.context.config.endpoint)) {
                var eventData = {
                    version: '1.0.0',
                    initiatorType: entryData.initiatorType,
                    duration: entryData.duration,
                    fileType: getResourceFileType(entryData.name),
                    transferSize: entryData.transferSize
                };
                if (_this.context.config.recordResourceUrl) {
                    eventData.targetUrl = entryData.name;
                }
                _this.recordEvent(PERFORMANCE_RESOURCE_EVENT_TYPE, eventData);
            }
        };
        this.pluginId = RESOURCE_EVENT_PLUGIN_ID;
        this.enabled = true;
        this.config = __assign(__assign({}, defaultConfig), config);
    }
    ResourcePlugin.prototype.load = function (context) {
        this.context = context;
        this.recordEvent = context.record;
        window.addEventListener(LOAD, this.resourceEventListener);
    };
    ResourcePlugin.prototype.enable = function () {
        if (this.enabled) {
            return;
        }
        this.enabled = true;
        window.addEventListener(LOAD, this.resourceEventListener);
    };
    ResourcePlugin.prototype.disable = function () {
        if (!this.enabled) {
            return;
        }
        this.enabled = false;
        if (this.resourceEventListener) {
            window.removeEventListener(LOAD, this.resourceEventListener);
        }
    };
    ResourcePlugin.prototype.getPluginId = function () {
        return this.pluginId;
    };
    return ResourcePlugin;
}());
export { ResourcePlugin };
